import GLightbox from 'glightbox';

export default class Gallery {
  constructor(element) {
    this.element = element;
  }

  mount() {
    const lightbox = GLightbox({
      selector: '.glightbox',
      autoplayVideos: false,
    });

    lightbox.on('open', () => {
      const closeButton = document.querySelector('.gclose');
      if (closeButton) {
        closeButton.setAttribute('aria-label', 'Fermer la fenêtre');
      }

      const nextButton = document.querySelector('.gnext');
      if (nextButton) {
        nextButton.setAttribute('aria-label', 'Suivante');
      }

      const prevButton = document.querySelector('.gprev');
      if (prevButton) {
        prevButton.setAttribute('aria-label', 'Précédente');
      }
    });
  }
}
